import { DateTime } from 'luxon';

export const STORAGE_KEY = 'trialSessionReview';
export const STORAGE_KEY_PROMO_CODE = 'trialSessionReviewPromoCode';
export const STORAGE_KEY_CONTINUE_THERAPY = 'trialSessionReviewContinueTherapy';

export type TrialSessionReview = {
  userId: string;
  sessionId: string;
  sessionStartTimestamp: number;
  hideForever: boolean;
  isOpen: boolean;
};

export const getReviewedSessions = (): TrialSessionReview[] => {
  const trialSessionReview = localStorage.getItem(STORAGE_KEY) ?? '';
  let reviewedSessions: TrialSessionReview[] = [];

  if (trialSessionReview) {
    try {
      reviewedSessions = JSON.parse(trialSessionReview) as TrialSessionReview[];
    } catch (error) {
      console.error(`Error in getReviewedSessions: ${(error as Error).message}`);
      localStorage.removeItem(STORAGE_KEY);
    }
  }

  return reviewedSessions;
};

export const saveReviewedSessions = (reviewedSessions: TrialSessionReview[]): void => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(reviewedSessions));
};

export const mergeSession = (sessionId: string, sessionData: Partial<TrialSessionReview>): void => {
  const reviewedSessions = getReviewedSessions();
  const sessionIndex = reviewedSessions.findIndex((session) => session.sessionId === sessionId);

  const newSession: TrialSessionReview = {
    sessionId,
    sessionStartTimestamp: sessionData.sessionStartTimestamp ?? DateTime.local().toMillis(),
    hideForever: sessionData.hideForever ?? false,
    isOpen: sessionData.isOpen ?? false,
    userId: sessionData.userId ?? '',
  };

  if (sessionIndex !== -1) {
    reviewedSessions[sessionIndex] = {
      ...reviewedSessions[sessionIndex],
      ...newSession,
    };
  } else {
    reviewedSessions.push(newSession);
  }

  saveReviewedSessions(reviewedSessions);
};

export const closeAllSessions = (): void => {
  const reviewedSessions = getReviewedSessions();
  reviewedSessions.forEach((session) => {
    session.isOpen = false;
  });
  saveReviewedSessions(reviewedSessions);
};

export const getTrialSessionReviewPromoCode = (): boolean => {
  const trialSessionReviewPromoCode = localStorage.getItem(STORAGE_KEY_PROMO_CODE) ?? 'false';
  return trialSessionReviewPromoCode === 'true';
};

export const getTrialSessionReviewContinueTherapy = (): boolean => {
  const trialSessionReviewContinueTherapy = localStorage.getItem(STORAGE_KEY_CONTINUE_THERAPY) ?? 'false';
  return trialSessionReviewContinueTherapy === 'true';
};

export const saveTrialSessionReviewPromoCode = (isOpened: boolean): void => {
  localStorage.setItem(STORAGE_KEY_PROMO_CODE, isOpened.toString());
};

export const saveTrialSessionReviewContinueTherapy = (isOpened: boolean): void => {
  localStorage.setItem(STORAGE_KEY_CONTINUE_THERAPY, isOpened.toString());
};

export const removeTrialSessionReviewPromoCode = (): void => {
  localStorage.removeItem(STORAGE_KEY_PROMO_CODE);
};

export const removeTrialSessionReviewContinueTherapy = (): void => {
  localStorage.removeItem(STORAGE_KEY_CONTINUE_THERAPY);
};
